import axios from "axios";

import store from "../../store";
import { configActions, basketActions, mandantActions, hinweiseActions } from "../../actions";
import sendError from "./sendError";
import { handleYesLogin } from "./handleYesLogin";
import clientConfig from "../../clientConfig";
import authenticationStorage from "../../storage/authentication-storage";
import { console } from ".";
import { handleTanAuth } from "./handleTanAuth";

const state = {
  loaded: false,
  initialized: false,
  error: null
};

export const sessionLoader = async (RouterMatch, parent) => {
  const { configStorage } = store.getState();
  const dispatch = store.dispatch;
  let error = null;
  console.log("session loader", RouterMatch, parent);

  if (parent && parent.parentMatch) error = await parent.parentMatch.loaderPromise;
  const yesLogin = await handleYesLogin();
  const tanAuthResponse = await handleTanAuth();
  const { token, verwaltung, tanAuth, callcenter, lightShop } = clientConfig.init();
  dispatch(configActions.setAuthToken(token));
  dispatch(configActions.setVerwaltung(verwaltung));
  dispatch(configActions.setCallcenter(callcenter));
  dispatch(configActions.setLightShop(lightShop));
  const objektheader = configStorage.getRequestHeader();
  axios.defaults.headers.common['request'] = JSON.stringify(objektheader);
  axios.defaults.headers.common['Pragma'] = 'no-cache';

  if (!yesLogin && !state.initialized && !configStorage.isVerseNeo()) {
    await dispatch(configActions.fetchSession(configStorage.getRequestData("session")))
      .then(_sessionid => {
        return dispatch(mandantActions.fetchMandantData(configStorage.getRequestData("mandant")));
      })
      .then(() => {
        // load order limit from new endpoint /mandant/orderLimit
        const orderLimitRequest = configStorage.getRequestData("orderLimitBootstrap");
        return dispatch(mandantActions.fetchMandantOrderLimit(orderLimitRequest));
      })
      .then(() => {
        return dispatch(basketActions.setOrderLimit());
      })
      .then(() => {
        return dispatch(mandantActions.fetchMandantLogo(configStorage.getRequestData("loadLogoImage")));
      })
      .then(() => {
        return dispatch(basketActions.fetchMasterData(configStorage.getRequestData("masterdata")));
      })
      .then(() => {
        return dispatch(hinweiseActions.fetchHinweise(configStorage.getRequestData("hinweise")));
      })
      .then(() => {
        state.initialized = true;
        state.error = null;
      })
      .catch(err => {
        console.error("e1", err);
        state.error = err;
        state.initialized = false;
        error = err;
      });
  } else if (yesLogin) { // Session wurde in handleYesLogin gesetzt    
    await Promise.all([
      dispatch(mandantActions.fetchMandantData(configStorage.getRequestData("mandant"))),
      dispatch(mandantActions.fetchMandantOrderLimit(configStorage.getRequestData("orderLimitBootstrap")))
    ])
      .then(() => {    
        return dispatch(basketActions.setOrderLimit());
      })
      .then(() => {
        return dispatch(basketActions.fetchMasterData(configStorage.getRequestData("masterdata")));
      })
      .then(() => {
        state.initialized = true;
        state.error = null;
      })
      .catch(err => {
        console.error("e3", err);
        error = err;
      });
  } else if (configStorage.isVerseNeo() && tanAuth && tanAuthResponse) { // Session wurde in handelTanAuth gesetzt
    dispatch(configActions.setTanAuth(tanAuth))
    await dispatch(configActions.restartSession(configStorage.getRequestData("session_ping")))
      .then(_sessionid => {
        return dispatch(mandantActions.fetchMandantData(configStorage.getRequestData("mandant")));
      })
      .then(() => {
        return dispatch(mandantActions.fetchMandantOrderLimit(configStorage.getRequestData("orderLimitBootstrap")));
      })
      .then(() => {        
        return dispatch(basketActions.setOrderLimit());
      })
      .then(() => {
        return dispatch(mandantActions.fetchMandantLogo(configStorage.getRequestData("loadLogoImage")));
      })
      .then(() => {
        return dispatch(basketActions.fetchMasterData(configStorage.getRequestData("masterdata")));
      })           
      .then(() => {
        return dispatch(configActions.setTanAuth(tanAuth));
      })
      .then(() => {
        state.initialized = true;
        state.error = null;
      })
      .catch(err => {
        dispatch(configActions.setTanAuth(!tanAuth));
        console.error("e4", err);
        error = err;
      });
  } else if (configStorage.isVerseNeo() && !authenticationStorage.isSignedIn && !authenticationStorage.isUserSignedIn) {
    await dispatch(configActions.fetchSession(configStorage.getRequestData("session")))
      .then(_sessionid => {
        return Promise.all([
          dispatch(mandantActions.fetchMandantData(configStorage.getRequestData("mandant"))),
          dispatch(mandantActions.fetchMandantOrderLimit(configStorage.getRequestData("orderLimitBootstrap"))),
          dispatch(hinweiseActions.fetchHinweise(configStorage.getRequestData("hinweise"))),
        ]);
      })
      .then(() => {
        // load order limit into basketStorage so recalcLimits has the correct limit from the start
        return dispatch(basketActions.setOrderLimit());
      })
      .then(() => {
        state.initialized = true;
        state.error = null;
      })
      .catch(err => {
        console.error("e1", err);
        state.error = err;
        state.initialized = false;
        error = err;
      });
  }
  if (error && error.message) {
    sendError(error, "session");
    return error;
  }
  return null;
};

export default sessionLoader;
